import { getNextSortConfig, sortReportRows } from "./taxRegisterReportTableConfig";

export { getNextSortConfig };

// indexed like possalemonitoringreport_head; amounts and % sort on the raw numbers the API sends
export const SALE_MONITORING_COLUMN_FIELDS = [
  null,
  "createdAt",
  "ref",
  "sales_person",
  "customer",
  "SKU",
  "item",
  "collection",
  "retail",
  "sale",
  "discount_percent",
  "discount",
  null,
  "user",
];

// SKU holds the number of SKUs on the order
const NUMERIC_FIELDS = new Set(["SKU", "retail", "sale", "discount_percent", "discount"]);

export const sortSaleMonitoringRows = (rows, sortConfig) =>
  sortReportRows(rows, sortConfig, SALE_MONITORING_COLUMN_FIELDS, NUMERIC_FIELDS);
